export const GRID_VARIATION = {
  default: {
    summary: {
      container: {
        md: 4,
        lg: 3,
      },
      userInfo: {
        md: 12,
      },
      rating: {
        md: 12,
      },
    },
    content: {
      md: 8,
      lg: 9,
    },
  },
  compact: {
    summary: {
      container: {
        md: 12,
        lg: 4,
      },
      userInfo: {
        md: 6,
      },
      rating: {
        md: 6,
      },
    },
    content: {
      md: 12,
      lg: 8,
    },
  },
}

export const NO_REVIEWS_COPY = {
  title: 'This reviewer only left a rating',
  pros: 'No pros were added to this review',
  cons: 'No cons were added to this review',
}
